import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20dark%20sports%20atmosphere%20background%2C%20abstract%20golden%20light%20streaks%20on%20dark%20surface%2C%20elegant%20and%20energetic%20vibe%2C%20clean%20composition%2C%20premium%20feel%2C%20no%20text%2C%20atmospheric%20sports%20theme%2C%20dramatic%20lighting%20contrast&width=1600&height=600&seq=kaiyun-cta-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/60"></div>

          <div className="relative z-10 px-6 py-14 md:py-20 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
              准备好开启体育之旅了吗？
            </h2>
            <p className="text-background-50/75 text-sm md:text-base mb-8 max-w-md mx-auto">
              加入数百万体育爱好者，体验极致的体育赛事服务
            </p>
            <button
              onClick={() => {
                navigate('/category/football');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-base"
            >
              立即加入
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}